import RenderManager from "../rendering/render-manager";

function getCameraPosition() {
    return ([RenderManager.activeCamera.position.x, RenderManager.activeCamera.position.y, RenderManager.activeCamera.position.z]);
}

function setAmbientLight(name, color, intensity, visible) {
    let currentLight = RenderManager.activeScene.getObjectByName(name);
    if (currentLight.type === "AmbientLight") {

        currentLight.color = new THREE.Color(color);
        currentLight.intensity = intensity;
        currentLight.visible = visible;

    } else {

        RenderManager.activeScene.remove(currentLight);
        const light = new THREE.AmbientLight(new THREE.Color(color));
        light.intensity = intensity;
        light.visible = visible;
        light.name = name;
        RenderManager.activeScene.add(light);

    }

    RenderManager.activeCamera.update = true;
}

function setDirectionalLight(name, color, intensity, positionX, positionY, positionZ, castShadow, visible) {
    let currentLight = RenderManager.activeScene.getObjectByName(name);

    if (currentLight.type === "DirectionalLight") {
        currentLight.color = new THREE.Color(color);
        currentLight.intensity = intensity;
        currentLight.position.x = positionX;
        currentLight.position.y = positionY;
        currentLight.position.z = positionZ;
        currentLight.castShadow = castShadow;
        currentLight.visible = visible;
    } else {
        RenderManager.activeScene.remove(currentLight);

        const light = new THREE.DirectionalLight(new THREE.Color(color), intensity, 0);

        light.castShadow = castShadow;
        light.visible = visible;
        light.position.x = positionX;
        light.position.y = positionY;
        light.position.z = positionZ;
        light.name = name;
        RenderManager.activeScene.add(light);
    }

    RenderManager.shadowMap.needsUpdate = true;
    RenderManager.activeCamera.update = true;
}

function toggleLight(light, callback) {
    let currentLight = RenderManager.activeScene.getObjectByName(light);

    if (currentLight.visible) { currentLight.visible = false; }
    else { currentLight.visible = true; }

    RenderManager.activeCamera.update = true;

    callback();
}


export { getCameraPosition, setAmbientLight, setDirectionalLight, toggleLight };